<template>
  <div class="wrap common-container el-row-overflow">
            <h2 class="public-title">项目优势</h2>
            <el-row :gutter="40">
                <el-col :md="12" :sm="12" :xs="12" v-for="(proItem,index) in proAdvantage" :key="index">
                    <div class="pro-advantage" @mouseenter="mouseFun(index)" @mouseleave="mouseFun(-1)">
                        <div class="advantage-content ">
                            <h4>{{proItem.name}}</h4>
                            <p :class="['advantage-detail', activeInd!=index?'over-ellipsis':'animate-status']">{{proItem.content}}</p>
                        </div>
                        <div class="advantage-cover">
                            <img :src="require('@/assets/images/img/'+proItem.imgSrc)" alt="">
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
</template>

<script>
import { defineComponent,ref,reactive} from 'vue'
export default defineComponent({
 setup(){
     const activeInd=ref(-1) //
     const proAdvantage=reactive([
            {
                name:'OMO模式',
                content:'通过统一文都网用户中心、订单中心、支付中心，实现线下培训交易和服务在线化，连接线下/线上培训以及资源渠道，为文都各机构运营过程中提供用户行为以及业务数据的跟踪、分析和预测，为线上/线下产品、营销、服务、教学模式融合赋能，为学员提供便捷、多元学习选择。',
                imgSrc:'img_omo.jpg'
            },
            {
                name:'智能学习系统',
                content:'利用大数据以及AI技术，在文都智能学习系统中进行数据规划和采集，通过学员兴趣图谱、学习习惯，进行用户价值分析，在学习过程中按照学习计划为学员提供个性化陪伴、练习、答疑和监督的新体验;通过数据化学习结果，记录并预测学习轨迹，根据学习的进展和效果，进行有针对性的推荐，提供自适应学习路径并激励学员高效学习。',
                imgSrc:'img_leraning.png'
            },
            {
                name:'教育大数据',
                content:'文都信息契合国务院提出的教育产业规划，致力于建设全领域智慧教育产业平台，促进教育资源的合理分配，提升全民学习效果。在文都集团数十年的教学经验、方法、数据的基础上，文都信息深度分析教育大数据，通过数据归集、分发、深度挖掘等机制，研发覆盖教务、教学乃至学员终身服务的智能学习系统。',
                imgSrc:'img_education.png'
            },
            {
                name:'智能管理系统',
                content:'基于成熟的ERP产品打造符合文都业务发展、融合人力资源、财务、业务等为一体的智能管理云;建设适用教育培训全产业链项目、聚焦文都特色的行业领先核心教务管理云;推广和普及以移动终端为主、便捷、统一的智慧办公云。',
                imgSrc:'img_administration.jpg'
            }
        ])
     const mouseFun=(ind)=>{
         activeInd.value=ind
     }
     return{
        proAdvantage,
        activeInd,
        mouseFun
     }
 }
})
</script>

<style lang="scss" scoped type="text/scss">
@mixin ellipsis($line:2){
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: $line;
    line-clamp: $line;
    -webkit-box-orient: vertical;
}
.pro-advantage{
    background:#fff;
    display:-moz-flex;
	 display:flex;
	 -moz-flex-direction:column;
	 -o-flex-direction:column;
	 flex-direction:column;
    height:486px;
    margin-bottom:40px;
    overflow: hidden;
    .advantage-content{
        padding:40px 40px 0;
        font-size:14px;
        color:#869099;
        h4{
            font-size:24px;
            color:#1B1D1F;
            margin-bottom:16px;
        }
    }
    .advantage-cover{
        position:relative;
        img{
            width:100%;
        }
    }
    .advantage-detail{
        // max-height:40px;
        height:40px;
        line-height: 20px;
        margin-bottom:40px;
    }
    .animate-status{
        height:auto;
        transition: all 3s ease-out;
    }
    .over-ellipsis{
        max-height:40px;
        @include ellipsis();
    }
    // &:hover{
        // img{
        //     transform:scale(1.03);
        //     transition:all 0.5s ease-out;
        //     transition-delay: 0.2s;
        //     -moz-transition-delay: 0.2s; /* Firefox 4 */
        //     -webkit-transition-delay: 0.2s; /* Safari 和 Chrome */
        //     -o-transition-delay: 0.2s; 
        // }
    // }
}
</style>
<style lang="css">
        @keyframes moveHeight
    {
        /* from {max-height:40px;}
        to {max-height:120px} */

         from {height:40px;}
        to {height:100px}
    }

    @-webkit-keyframes moveHeight /*Safari and Chrome*/
    {
         /* from {max-height:40px;}
        to {max-height:120px} */
         from {height:40px;}
        to {height:100px}
    }
    .pro-advantage:hover .advantage-detail{

        animation:moveHeight 0.2s;
        -webkit-animation:moveHeight 0.2s;
       animation-iteration-count:1; /*播放一次 */
        animation-fill-mode:forwards;  /*保持最后一个状态*/
    }
</style>